import * as React from 'react';
import Divider from '@mui/material/Divider';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import FAQ from './components/FAQ';
import Highlights from './components/Highlights';

export default function MainPage({ highlightsRef, servicesRef, whyChooseUsRef, faqsRef }) {
  return (
    <div>
      <div ref={highlightsRef}>
        <Highlights />
      </div>
      <Divider />
      <div ref={servicesRef}>
        <Services />
      </div>
      <Divider />
      <div ref={whyChooseUsRef}>
        <WhyChooseUs />
      </div>
      <Divider />
      <Divider />
      <div ref={faqsRef}>
        <FAQ />
      </div>
      <Divider />
    </div>
  );
}
